import produce from 'immer';

import { defaultProcessingState } from '../utils';

import { SIGN_IN_START, SIGN_IN_FULFILL, SIGN_IN_REJECT } from './authentication.actions';

const defaultState = {
  ...defaultProcessingState(),
  user: null,
};

export default produce((draft, action = {}) => {
  switch (action.type) {
    case SIGN_IN_START: {
      ++draft.processing;
      return draft;
    }

    case SIGN_IN_FULFILL: {
      --draft.processing;
      draft.error = null;
      draft.user = action.payload;
      return draft;
    }

    case SIGN_IN_REJECT: {
      --draft.processing;
      draft.error = action.payload;
      draft.user = null;
      return draft;
    }

    default:
      return draft;
  }
}, defaultState);
